// extracted by mini-css-extract-plugin
module.exports = {"content":"src-components-common-TaxAuthProtocol-protocol-AuthProtocol-XZProtocolContent-__index__content--3iH2x"};